import { withInstall } from '@lit-element/utils'

import Rate from './src/rate.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtRate: SFCWithInstall<typeof Rate> = withInstall(Rate)
export default LtRate

export * from './src/rate'
